import { createSlice } from '@reduxjs/toolkit';
import { login, getLoggedInUser } from '../authActions';

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    data: {},
    loggedInUser: {},
    error: '',
    loading: false
  },
  reducers: {
    clearState: () => {
      // Remove the istNetworkChecked flag from localStorage
      localStorage.removeItem('istNetworkChecked');
      return { data: {} };
    }
  },
  extraReducers: {
    [login.pending]: (state) => ({
      ...state,
      error: '',
      loading: true
    }),
    [login.fulfilled]: (state, { payload }) => ({
      ...state,
      loading: false,
      data: payload.data
    }),
    [login.rejected]: (state, { payload }) => ({
      ...state,
      error: 'There is an error occured, please try again later !',
      loading: false
    }),
    [getLoggedInUser.pending]: (state) => ({
      ...state,
      error: '',
      loading: true
    }),
    [getLoggedInUser.fulfilled]: (state, { payload }) => ({
      ...state,
      loading: false,
      loggedInUser: payload.data
    }),
    [getLoggedInUser.rejected]: (state, { payload }) => ({
      ...state,
      error: 'There is an error occured, please try again later !',
      loading: false
    })

  }
});

export const { clearState } = loginSlice.actions;
export default loginSlice.reducer;
